var map = {
	"./clinic-hover.svg": "67cc",
	"./delete-hover.svg": "f022",
	"./document-hover.svg": "28fc",
	"./edit-hover.svg": "b1f5",
	"./message-hover.svg": "083a",
	"./users-hover.svg": "8826"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "14ba";